import React from "react";
import PortfolioView from "./components/PortfolioView";
import { Routes, Route } from "react-router-dom";
import ProjectGallery from "./components/ProjectGallery";
import YearGallery from "./components/YearGallery";

import artworks from "./artworks.json";
import projects from "./projects.json";

function App() {

  return (
    <div>
      <Routes>
        <Route path="/" element={<PortfolioView artworks={artworks} />} />
        <Route path=":year" element={<YearGallery artworks={artworks} />} />
        <Route path=":year/:projectName" element={<ProjectGallery artworks={artworks} projectDescriptions={projects}/>} />
      </Routes>
    </div>
  );
}

export default App;
